/**
 * Array of all valid campaign claim include relations
 * Used for runtime validation
 */
export const VALID_CAMPAIGN_CLAIM_RELATIONS = [
    'campaign',
    'user',
    'business',
    'triggerSource',
    'transactions'
];
/**
 * Type guard to validate campaign claim include relation at runtime
 *
 * @param value - String to validate
 * @returns True if value is a valid CampaignClaimIncludeRelation
 */
export function isValidCampaignClaimRelation(value) {
    return VALID_CAMPAIGN_CLAIM_RELATIONS.includes(value);
}
//# sourceMappingURL=campaign-claim-include-relation.type.js.map